/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { baseRequest } from './baseRequest';
import { uploadKey } from './keys';
const baseRoute = '/api/internal/files';
export const uploadFile = uploadFileParams => {
  const {
    config,
    file
  } = uploadFileParams;
  const formData = new FormData();
  if ('loanId' in uploadFileParams) {
    formData.append('loanId', uploadFileParams.loanId);
  } else if ('fileType' in uploadFileParams) {
    if (uploadFileParams.fileType === 'NOTARY_DIGITAL_CERTIFICATE') {
      return uploadKey(file);
    }
    formData.append('fileType', uploadFileParams.fileType);
  } else {
    throw new Error('Validation failure: Either fileType or loanId needs to be passed.');
  }
  formData.append('file', file);
  const requestConfig = {
    headers: {
      'content-type': 'multipart/form-data'
    },
    onUploadProgress: config.onUploadProgress
  };
  return baseRequest.post(`${baseRoute}/`, formData, requestConfig);
};